<template>
    <div class="col-md-4">
        <input type="hidden" v-if="isEditing" v-model="user.role" name="role">
        <div class="row margined-bottom" v-if="!isEditing">
            <div class="col-md-12">
                <label for="first_name">Select Type Of Contractor</label>
            </div>
            <div class="col-md-12">
                <select v-model="user.role" name="role" class="form-select">
                    <option :value="null">Select Type</option>
                    <option v-for="role in roles" :key="role.slug" v-bind:value="role.slug">{{ role.name }}</option>
                </select>
            </div>
        </div>

        <div v-if="this.user.role || isEditing">
            <div class="row margined-bottom" v-if="isEditing">
                <div class="col-md-12">
                    <label class="control-label" for="email">Email</label>
                    <input type="hidden" id="user_id" name="user_id" v-model="user.id">
                    <input type="hidden" id="email" name="email" v-model="user.email" class="disabled">
                    <input class="form-control" type="text" id="email-show" name="email-show" v-model="user.email" disabled="disabled">
                    <validation-error :errors="errors.email" :class="'validation-alert'"></validation-error>

                </div>
            </div>
            <div class="row margined-bottom" v-if="!isEditing">
                <div class="col-md-12">
                    <label class="control-label" for="email">Email</label>
                    <button
                        type="button"
                        class="btn btn-help-icon"
                        data-bs-toggle="tooltip"
                        data-bs-html="true"
                        title="You can search users with name or email"
                        data-bs-container="body"
                        data-bs-placement="right"
                    >?</button>
                </div>
                <div class="col-md-12">
                    <input type="hidden" id="user_id" name="user_id" v-model="user.id">
                    <user-search-component
                        v-bind:field="searchField"
                        v-bind:role="roles.map(role => role.slug)"
                        v-bind:trigger-text="''"
                        v-bind:default-query="user.email"
                        v-bind:as-mail-input="true"
                        v-bind:default-user-id="parseInt(user.user_id)"
                    ></user-search-component>
                    <validation-error :errors="errors.email" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row margined-bottom">
                <div class="col-md-12">
                    <label for="first_name">First Name</label>
                </div>
                <div class="col-md-12">
                    <input type="text" class="form-control" id="first_name" name="first_name" v-model="user.first_name" :readonly="isEditing" required>
                    <validation-error :errors="errors.first_name" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row margined-bottom">
                <div class="col-md-12">
                    <label for="last_name">Last Name</label>
                </div>
                <div class="col-md-12">
                    <input type="text" class="form-control" id="last_name" name="last_name" v-model="user.last_name" :readonly="isEditing" required>
                    <validation-error :errors="errors.last_name" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row margined-bottom">
                <div class="col-md-12">
                    <label for="phone">Phone Number</label>
                </div>
                <div class="col-md-12">
                    <input type="text" class="form-control" id="phone" name="phone" v-model="user.phone" :readonly="isEditing">
                    <validation-error :errors="errors.phone" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row margined-bottom">
                <div class="col-md-12">
                    <label for="tag_number">Tag</label>
                </div>
                <div class="col-md-12" v-if="isEditing">
                    <div v-for="tag in user.tags">
                        <div class="input-group tag_number-container">
                            <input :minlength="tagNumberLengths.min" :maxlength="tagNumberLengths.max"  type="text" v-bind:value="tag.tag_number" class="tag-input tag_number form-control" disabled>
                        </div>
                    </div>
                    <validation-error :errors="errors.tag_number" :class="'validation-alert'"></validation-error>
                </div>
                <div class="col-md-12" v-if="!isEditing">
                    <div class="input-group" v-if="user.tags.length < 1">
                        <input :minlength="tagNumberLengths.min" :maxlength="tagNumberLengths.max" type="text" name="tag_number" id="tag_number" v-model="user.tag_number" class="tag-input form-control" required>
                    </div>
                    <div v-for="tag in user.tags">
                        <div class="input-group tag_number-container">
                            <input :minlength="tagNumberLengths.min" :maxlength="tagNumberLengths.max" type="text" v-bind:value="tag.tag_number" class="tag-input tag_number form-control" disabled="disabled">
                        </div>
                    </div>
                    <validation-error :errors="errors.tag_number" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row" v-if="user.role !== 'contractor'">
                <div class="col-md-12">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="is_all_inventories" name="is_all_inventories" v-model="user.is_all_inventories" :checked="user.is_all_inventories"/>
                        <label class="form-check-label contractor-form-label" for="is_all_inventories">All Inventories</label>
                    </div>
                    <validation-error :errors="errors.is_all_inventories" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row margined-bottom">
                <div class="col-md-12">
                    <label>Choose An Office (optional)</label>
                </div>
                <div class="col-md-12">
                    <input v-for="inventory in selectedInventories" type="hidden" name="inventories[]" :value="inventory.id">

                    <multiselect
                        v-model="selectedInventories"
                        :options="inventories"
                        track-by="fullName"
                        label="fullName"
                        placeholder="Choose An Office"
                        :searchable="true"
                        :loading="loadingInventories"
                        :internal-search="true"
                        :allow-empty="true"
                        :multiple="true"
                        :style="{ height: 'auto'}"
                        :disabled="user.is_all_inventories"
                    ></multiselect>
                    <validation-error :errors="getErrorMessages('inventories')" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row margined-bottom">
                <div class="col-md-12">
                    <label for="end_date">Valid Until (12 months max)</label>
                </div>
                <div class="col-md-12">
                    <input type="text" name="end_date" class="form-control" @focus="initDatePicker" :value="formattedEndDate" required />
                    <validation-error :errors="errors.end_date" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row mb-3 clearfix">
                <label>Limit access to:</label>
                <br />
                <label>Days Of the week</label>
                <br>
                <div class="btn-group" data-bs-toggle="buttons">
                    <template v-for="(day, key, index) in daysOfWeek">
                        <input class="btn-check" :id="`day-${key}`" :value="index >= Object.keys(daysOfWeek).length-1 ? 0 : index+1" :name="`dow[${key}]`" type="checkbox" autocomplete="off" :checked="getSelectedDow(key)">
                        <label :for="`day-${key}`"  class="btn btn-light">
                            {{ day }}
                        </label>
                    </template>
                </div>
                <validation-error :errors="errors.dow" :class="'validation-alert'"></validation-error>
            </div>

            <div class="row margined-bottom">
                <div class="row mb-3">
                    <div class="col-6">
                        <label for="start_time">From</label>
                        <input type="text" class="form-control" name="start_time" ref="timepicker_start" @focus="initTimePicker" :value="user.start_time" required>
                    </div>
                    <div class="col-6">
                        <label for="end_time">Until</label>
                        <input type="text" class="form-control" name="end_time" ref="timepicker_end" @focus="initTimePicker" :value="user.end_time" required>
                    </div>
                </div>
                <div class="col-md-12">
                    <validation-error :errors="errors.start_time" :class="'validation-alert'"></validation-error>
                    <validation-error :errors="errors.end_time" :class="'validation-alert'"></validation-error>
                </div>
            </div>

            <div class="row margined-bottom">
                <div class="col-md-12">
                    <form-sender-button
                        v-bind:alert-text="senderWarning"
                        v-bind:form-id="'contractor-access-form'"
                        v-bind:btn-text="btnText"
                    ></form-sender-button>
                    <a type="button" class="btn btn-danger float-end" :href="previousUrl"> Cancel </a>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import {EventBus} from '../EventBus';
import Multiselect from 'vue-multiselect';
import UserSearchComponent from './Shared/UserSearchComponent.vue';
import ValidationError from './UI/ValidationError.vue';
import Inventories from "../Services/Inventories";
import get from 'lodash/get';
import Utils from '../Services/Utils';
import dayjs from "dayjs";
import {TempusDominus} from "@eonasdan/tempus-dominus";
import {initTooltips} from "../Services/Tooltip";

export default {
        name: "ContractorAccessFormComponent",
        components: {
            Multiselect,
            UserSearchComponent,
            ValidationError
        },
        props: {
            centreId: {
                type: Number,
                required: true
            },
            dateFormat:{
                type: String,
                required: true
            },
            roles: {
                type: Array
            },
            searchField: {
                type: Array
            },
            old: {
                type: [Object, Array]
            },
            errors: {
                type: [Object, Array]
            },
            daysOfWeek: {
                type: Object
            },
            defaultDays: {
                type: Array
            },
            businessDay: {
                type: Object
            },
            previousUrl: {
                type: String,
                default: ""
            },
            btnText: {
                type: String,
                default: "Send"
            },
            senderWarning: {
                type: String,
                default: "Are you sure?"
            },
            isEditing: {
                type: Boolean,
                default: false,
            },
            tagNumberLengths: {
                type: Object,
            },
            vendor: {
                type: String,
            }
        },
        data: function() {
            return {
                user: {
                    tags: [],
                    start_time: dayjs(this.businessDay?.opens, 'HH:mm:ss').format('HH:mm'),
                    end_time: dayjs(this.businessDay?.closes, 'HH:mm:ss').format('HH:mm'),
                    ...this.old
                },
                inventories: [],
                loadingInventories: false,
                selectedInventories: null,
                datePickerOptions: {
                    format: this.dateFormat.toUpperCase()
                        .replace("Y", "yyyy")
                        .replace("M", "MM")
                        .replace("D", "dd"),
                    minDate: dayjs().toDate(),
                    maxDate: dayjs().add(1, 'years').toDate(),
                },
                timePickerOptions: {
                    format: "HH:mm",
                    locale: 'en-GB', // default is 'en' (en-US) which will add AM/PM button
                },
                datePicker: null,
                timePickers: new Set(),
                originalEndDate: null,
                dateHasChanged: false,
            }
        },
        watch: {
            'user.role'(newValue) {
                if (newValue) {
                    this.$nextTick(() => {
                        const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                        initTooltips(tooltipTriggerList);
                    });
                }
            }
        },
        mounted() {
            EventBus.on('user-selected', this.userSelected);
            EventBus.on('all-forms-cancelled', this.clearForm);
            this.getInventories();
            this.originalEndDate = this.user.end_date;
        },
        methods: {
            userSelected(user) {
                user.tags = user.tags.filter((tag) => {
                    return tag.vendor === this.vendor && (!tag.centre_id || tag.centre_id === this.centreId);
                });
                this.user = {...this.user, ...user};
            },

            getInventories() {
                this.loadingInventories = true;
                Inventories.list(this.centreId).then(inventories => {
                    this.inventories = inventories.map(inventory => {
                        inventory.fullName = `${inventory.name} - ${get(inventory, 'product.name', '')}`;
                        return inventory;
                    });
                    this.loadingInventories = false;
                    this.setOldInventories();
                });
            },

            clearForm() {
                this.user = {
                    tags: []
                };
                this.selectedInventories = false;
            },

            setOldInventories() {
                if (!this.old.inventories) {
                    return;
                }

                this.selectedInventories = this.inventories.filter(inv => this.old.inventories.includes(inv.id.toString()));
            },

            getSelectedDow(key) {
                if (Object.keys(this.old).length > 0) {
                    return Object.keys(this.old.dow || {}).includes(key);
                } else if (this.defaultDays) {
                    return this.defaultDays.includes(key);
                }

                return false;
            },

            getErrorMessages(key) {
                return Utils.getErrorMessages(this.errors, key);
            },

            initDatePicker() {
                if (this.datePicker) {
                    return;
                }
                const input = event.target;
                this.datePicker = new TempusDominus(input, {
                    display: {
                        components: {
                            clock: false
                        }
                    },
                    localization: {
                        format: this.datePickerOptions.format
                    },
                    restrictions: {
                        minDate: this.datePickerOptions.minDate,
                        maxDate: this.datePickerOptions.maxDate
                    }
                });
                input.addEventListener('change.td', () => {
                    this.updateUserProperty(input);
                })
            },

            initTimePicker() {
                const input = event.target;
                if (this.timePickers.has(input)) {
                    return;
                }
                new TempusDominus(input, {
                    display: {
                        components: {
                            calendar: false,
                        }
                    },
                    localization: {
                        format: this.timePickerOptions.format,
                        locale: this.timePickerOptions.locale,
                    }
                });
                this.timePickers.add(input);
                input.addEventListener('change.td', () => {
                    this.updateUserProperty(input);
                })
            },
            updateUserProperty(input) {
                const propertyName = input.name;
                const newValue = input.value;
                if (propertyName === 'end_date') {
                    this.dateHasChanged = true;
                }
                this.$set(this.user, propertyName, newValue);
            }
        },
        computed: {
            formattedEndDate() {
                if (!this.dateHasChanged && this.user.end_date && this.originalEndDate && this.errors.length === 0) {
                    return this.$formatDate(this.user.end_date, this.dateFormat);
                }

                return this.user.end_date;
            }
        },
    }
</script>

<style scoped>
    .tag_number-container {
        margin-bottom: 1rem;
    }

    .tag_number-container > .tag_number {
        border: 0;
        box-shadow: none;
    }

    .contractor-form-label {
        text-transform: uppercase;
        color: #babfbf;
        font-size: 11px;
        font-weight: bold;
    }
    input[type=text]:read-only {
        background-color: #eeeeee;
        opacity: 1;
        border: 0;
        box-shadow: none;
        cursor: not-allowed;
    }
</style>
